import { useMemo } from 'react';

import { useNearestClub } from '@interlayer/js/app/hooks/postCodeFinder/hooks/useNearestClub';
import { usePostCodeSelector } from '@interlayer/js/app/store/hooks/usePostCodeSelector';

import { MAX_DISTANCE_NEAREST_CLUB } from './constants';

export const useNearestClubByPostcode = (nearestCount = 0) => {
    const { clubsNearest, getNearestClubs } = useNearestClub();
    const { isClubListLoaded, isLoading: isLoadingNearestClub } = usePostCodeSelector();

    const filteredClubs = useMemo(() => {
        let clubList = clubsNearest || [];

        clubList = nearestCount && nearestCount > 0
            ? clubList.slice(0, nearestCount)
            : clubList?.filter(({ Distance }) => Distance && Distance <= MAX_DISTANCE_NEAREST_CLUB);

        return clubList.sort(({ Distance: a }, { Distance: b }) => Number(a) - Number(b))
            .map(({ Name, BuzzId }) => ({ label: Name, value: BuzzId }))
            || [];
    }, [clubsNearest, nearestCount]);

    return {
        getNearestClubs,
        clubsNearest: filteredClubs,
        isLoadingNearestClub: !isClubListLoaded && isLoadingNearestClub
    };
};
